import { Splide } from '@splidejs/splide';

export default () => {
	const sections = document.querySelectorAll('.quote');

	sections.forEach(function(section) {
		const slider = section.querySelector('.splide');
		if (slider) {
			const splide = new Splide( slider, {
				type   : 'fade',
				rewind  : 1,
				autoplay: true,
				interval: 5000,
				perPage: 1,
				pagination: false,
				arrows: false,
				speed: 0,
				// pauseOnFocus: false,
				// pauseOnHover : false
			}).mount();

			const btnPrev = section.querySelector('.js-arrow-prev');
			const btnNext = section.querySelector('.js-arrow-next');

			if (btnPrev && btnNext) {
				btnPrev.addEventListener('click', (e) => {
					splide.go( '<' )
				});
				btnNext.addEventListener('click', (e) => {
					splide.go( '>' )
				});
			}

		}
	});
}